import { useState } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { Button } from "../../common/Button";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
    Span,
  ImageWrapper
} from "./styles";

const Header = () => {
  const [visible, setVisibility] = useState(false);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const MenuItem = () => {
      const scrollTo = (id: string, offset = 0) => {
          const element = document.getElementById(id);
          if (element) {
              const top = element.getBoundingClientRect().top + window.pageYOffset + offset;
              window.scrollTo({ top, behavior: "smooth" });
          }
      };

    return (
      <>
        <CustomNavLinkSmall onClick={() => scrollTo("middle")}>
          <Span>{"About"}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("service", -80)}>
          <Span>{"Service Area"}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("photo", -100)}>
          <Span>{"Georgia"}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall as="a" href="https://www.centeripa.com" target="_blank" rel="noopener noreferrer">
            <ImageWrapper>
                <img src="/img/center_logo.jpg" alt="Center IPA" className="hoverable-logo"/>
            </ImageWrapper>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall
          style={{ width: "180px" }}
          onClick={() => scrollTo("joinus")}
        >
          <Span>
            <Button>{"Contact"}</Button>
          </Span>
        </CustomNavLinkSmall>
      </>
    );
  };

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <SvgIcon src="popids_logo.svg" width="300px" height="64px" />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <MenuItem />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
